// extracted by mini-css-extract-plugin
export default {"Label":"SelectInput_Label__hd0IcNJA","Select":"SelectInput_Select__YuZ0ue8C"};